import { AppErrorCard } from '@components/error-card/app-error-card';
import { ScreenReaderElement } from '@components/screen-reader/screen-reader-element';
import { StandardButton } from '@eika/button';
import { useChildEligibilities } from '@react-query/hooks/query/use-child-eligibilities';
import { useTranslation } from '@translations';

export const MyChildrenError = () => {
    const { error, refetch } = useChildEligibilities();
    const { tryAgain, listOfChildren } = useTranslation();

    if (!error) {
        return null;
    }

    return (
        <AppErrorCard description={listOfChildren.error} exception={error} data-testid="my-children-error">
            <ScreenReaderElement text={listOfChildren.error} role="alert" />
            <StandardButton
                onClick={() => {
                    refetch();
                }}
            >
                {tryAgain}
            </StandardButton>
        </AppErrorCard>
    );
};
